module.exports = __webpack_public_path__ + "img/background-main-mobile-credit.bc27f8c0.svg";